import { Segment } from "../../../domain/segment/segment";
import { SegmentActionTypes } from "../../action-types";
import { SegmentActions } from "../../actions";
import produce from 'immer';


interface SegmentState {
    loading: boolean | null;
    segments: Segment[] | null,
    count: number,
    error: string | null,
    entityLoading: boolean,
    entityError: string | null,
}

const initialState: SegmentState = {
    loading: null,
    segments: null,
    count: 0,
    error: null,
    entityLoading: false,
    entityError: null,
}



const reducer = produce((state: SegmentState = initialState, action: SegmentActions) => {
    switch (action.type) {
        case SegmentActionTypes.SEGMENT_REQUEST_SEND:
            state.loading = true;
            return state;
        case SegmentActionTypes.SEGMENT_SUCCESS:
            state.loading = false;
            state.segments = action.payload.list;
            state.count = action.payload.count;
            return state;
        case SegmentActionTypes.SEGMENT_ERROR:
            state.loading = false;
            state.error = action.payload;
            return state;
        case SegmentActionTypes.SEGMENT_UPDATE_REQUEST:
            state.entityLoading = true
            state.entityError = ""
            return state;
        case SegmentActionTypes.SEGMENT_UPDATE_SUCCESS:
            state.entityLoading = false
            state.segments!.map((segment) => segment.Id() === action.payload.Id() ? action.payload : segment)
            state.entityError = ""
            return state;
        case SegmentActionTypes.SEGMENT_UPDATE_ERROR:
            state.entityLoading = false
            state.entityError = action.payload;
            return state;
        case SegmentActionTypes.SEGMENT_CREATE_REQUEST:
            state.entityLoading = true
            state.entityError = ""
            return state;
        case SegmentActionTypes.SEGMENT_CREATE_SUCCESS:
            state.entityLoading = false
            state.segments!.push(action.payload)
            state.entityError = ""
            return state;
        case SegmentActionTypes.SEGMENT_CREATE_ERROR:
            state.entityLoading = false
            state.entityError = action.payload;
            return state;
        case SegmentActionTypes.SEGMENT_DELETE_SUCCESS:
            state.segments = state.segments!.filter((segments) => segments.Id() !== action.payload)
            return state;
        default:
            return state;
    }
})

export default reducer;
